<template>
  <!-- <div class="box"> -->
  <transition-group class="box" name="fade" tag="div">
    <img key="1" class="img" :src="i1" v-show="!active" :style="rs1" @click="$emit('click')" />
    <img key="2" class="img2" :src="i2" v-show="active" :style="rs2" @click="$emit('click')" />
  </transition-group>
    <!-- {{ rs1 }} -->
  <!-- </div> -->
</template>

<script>
export default {
  props: {
    active: {},
    i1: {},
    i2: {},
    i1s: {},
    i2s: {},
    top1: {
      default: 0
    },
    top2: {
      default: 0
    },
    left1: {
      default: 0
    },
    left2: {
      default: 0
    }
  },
  computed: {
    rs1 () {
      return {
        transform: `scale(${this.i1s})`,
        top: 20 + this.top1 + 'px',
        left: this.left1 + 'px'
      }
    },
    rs2 () {
      return {
        transform: `scale(${this.i2s * 1.1})`,
        top: 20 + this.top2 + 'px',
        left: this.left2 + 'px'
      }
    }
  }
}
</script>

<style scoped>
.box{
  position: absolute;
  width: 120px;
  height: 120px;
}
.box-rel{
  position: relative;
  width: 120px;
  height: 120px;
}
.img2{
  z-index: 2;
  position: absolute;
}
.img{
  position: absolute;
  z-index: 1;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/KidsWishes/Items/ItemHolder.vue